import { WebsiteSharedActions, WebsiteSharedActionTypes } from './shared.action';
import { WebsiteSharedState, initialState } from './shared.state';
import { createSelector, createFeatureSelector } from '@ngrx/store';

export const getProjectsState = createFeatureSelector<WebsiteSharedState>('websiteShared');

export const get_mega_menu = createSelector(
    getProjectsState,
    state => state.mega_menu
);

export const get_mou_gallery = createSelector(
    getProjectsState,
    state => state.mou_gallery
);

export const get_mou_gallery_details = createSelector(
    getProjectsState,
    state => state.mou_gallery_details
);

export const getError = createSelector(
    getProjectsState,
    state => state.error
);

export function WebsiteSharedReducer(state = initialState, action: WebsiteSharedActions): WebsiteSharedState {
    switch (action.type) {

        case WebsiteSharedActionTypes.FETCH_MEGA_MENU_SUCCESS:
            return {
                ...state,
                mega_menu: action.payload,
                error: { ...state.error, mega_menu_error: null }
            }

        case WebsiteSharedActionTypes.FETCH_MEGA_MENU_FAIL:
            return {
                ...state,
                mega_menu: state.mega_menu,
                error: { ...state.error, mega_menu_error: action.payload }
            }

        case WebsiteSharedActionTypes.FETCH_MOU_GALLERY_SUCCESS:
            return {
                ...state,
                mou_gallery: action.payload,
                error: { ...state.error, mou_gallery_error: null }
            }

        case WebsiteSharedActionTypes.FETCH_MOU_GALLERY_FAIL:
            return {
                ...state,
                mou_gallery: state.mou_gallery,
                error: { ...state.error, mou_gallery_error: action.payload }
            }

        case WebsiteSharedActionTypes.FETCH_MOU_GALLERY_DETAILS_SUCCESS:
            return {
                ...state,
                mou_gallery_details: action.payload,
                error: { ...state.error, mou_gallery_details_error: null }
            }

        case WebsiteSharedActionTypes.FETCH_MOU_GALLERY_DETAILS_FAIL:
            return {
                ...state,
                mou_gallery_details: state.mou_gallery_details,
                error: { ...state.error, mou_gallery_details_error: action.payload }
            }

        case WebsiteSharedActionTypes.FETCH_MEGA_MENU:
        case WebsiteSharedActionTypes.FETCH_MOU_GALLERY:
        case WebsiteSharedActionTypes.FETCH_MOU_GALLERY_DETAILS:
        default:
            return state;
    }
}